import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { BorrowerCard, CoborrowerCard } from './card-lenses';

const ResidenceSoldPrior = ({ model, onChange, ...cardProps }) => (
  <Card title="Will this residence be sold prior to purchasing the new property?" {...cardProps}>
    <BooleanRadioButtons
      name="residenceSoldPrior"
      value={model.get('residenceSoldPrior')}
      onChange={onChange.bind(null, 'residenceSoldPrior')}
    />
  </Card>
);

ResidenceSoldPrior.completed = ({ model }) => model.get('residenceSoldPrior') != null;

export const BorrowerResidenceSoldPrior = BorrowerCard(
  ResidenceSoldPrior,
  'BorrowerResidenceSoldPrior'
);

export const CoborrowerResidenceSoldPrior = CoborrowerCard(
  ResidenceSoldPrior,
  'CoborrowerResidenceSoldPrior'
);



// WEBPACK FOOTER //
// ./src/cards/residence-sold-prior.js